import _ from 'lodash';
import moment from 'moment';
import { translate } from '../../../../scripts/core/tools/translate';

import environment from '../../../../scripts/environment';

export class CitiesFilterFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const data = [];

        const startDate = environment.get('CONFIG.FILTERS.STARTYEAR');
        const endDate = environment.get('CONFIG.FILTERS.ENDYEAR');

        data.push({
            name: 'demography',
            position: 1,
            fields: [{
                title: translate('Common.Population'),
                name: 'demography',
                dataSource: [
                    { text: '​>= ​0', value: '0:1000000000' },
                    { text: '< 25k', value: '0:25000' },
                    { text: '25k - 50k', value: '25000:50000' },
                    { text: '50k - 100k', value: '50000:100000' },
                    { text: '100k - 500k', value: '100000:500000' },
                    { text: '500k - 1.000k', value: '500000:1000000' },
                    { text: '> 1.000k', value: '1000000:1000000000' }
                ],
                value: 'value',
                text: 'text',
                type: 'dropdown',
                index: 6,
                noPlaceholder: true
            }]
        }, {
            name: 'domiciles_target',
            position: 2,
            fields: [{
                title: 'DNT',
                description: translate('Common.HouseholdsTargetAlt'),
                name: 'domicilesTarget',
                dataSource: [
                    { text: '​>= ​0', value: '0:1000000000' },
                    { text: '​< 2.5k', value: '0:2500' },
                    { text: '2.5k - 5​k', value: '2500:5000' },
                    { text: '5k - 10k', value: '5000:10000' },
                    { text: '10k - 25​k', value: '10000:25000' },
                    { text: '25​k - 50​k', value: '25000:50000' },
                    { text: '50​k - 100​k', value: '50000:100000' },
                    { text: '​> ​100​k', value: '100000:1000000000' }
                ],
                value: 'value',
                text: 'text',
                type: 'dropdown',
                index: 0,
                noPlaceholder: true
            }]
        }, {
            name: 'registrations',
            position: 2,
            fields: [{
                type: 'separator'
            }, {
                title: translate('Common.Registrations'),
                name: 'registrations',
                dataSource: [
                    { text: '​>= ​0', value: '0:1000000000' },
                    { text: '​< 1k​', value: '0:1000' },
                    { text: '1​k - 3​k', value: '1000:3000' },
                    { text: '3​k - 5k', value: '3000:5000' },
                    { text: '5​k - 10​k', value: '5000:10000' },
                    { text: '1​​0​k - 25​k', value: '10000:25000' },
                    { text: '​> ​25​k', value: '25000:1000000000' }
                ],
                value: 'value',
                text: 'text',
                type: 'dropdown',
                index: 0,
                noPlaceholder: true
            }]
        }, {
            name: 'date_year',
            data: this.getDateDataSource(startDate, endDate),
            position: 3,
            fields: [{
                title: translate('Common.Year'),
                name: 'year',
                value: 'yearValue',
                text: 'yearText',
                type: 'dropdown',
                index: 3,
                noPlaceholder: true
            }, {
                title: translate('Common.Months'),
                name: 'month',
                value: 'monthValue',
                text: 'monthText',
                type: 'slider',
                range: true
            }]
        });

        return data;
    }

    getDateDataSource (startDate, endDate) {
        const getDates = (start, end) => {
            const dates = [];
            let currentDate = start;

            const addMonth = function (value) {
                const date = new Date(this.valueOf());
                return moment(date).add(value, 'month').toDate();
            };

            while (currentDate <= end) {
                dates.push(currentDate);
                currentDate = addMonth.call(currentDate, 1);
            }
            return dates;
        };

        const dates = getDates(startDate, endDate);

        return _.map(dates, date => {
            const d = moment(date);
            return {
                yearText: d.format('YYYY'),
                yearValue: Number(d.format('YYYY')),
                monthText: d.format('MMM'),
                monthValue: Number(d.format('MM'))
            };
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/cities.factory.js